import keepSameHeightTitles from './keepSameHeightTitles';
import handleNewColorSelection from './selectNewColor';
import marketingBlock from './marketingBlock';
import initSEO from './seo';
import initSubCategoriesMenu from './subCategoriesMenu';
import initSmartBanner from '../smart-banner';
import initThirdLevelURL from './third-level-url';
import { initFiltering } from './filtering';
import { debounce } from '../../core/helpers';

// This is happening AFTER loading the Nosto collection called from theme.js
export default async () => {
  if (document.querySelector('.template-collection') === null) {
    return;
  }

  if (document.querySelector('[data-collection-grid]')) {
    // Add the marketing block if any (listener based)
    // Needs to be declared before initFiltering() that sends the event to avoid a race condition
    marketingBlock();
  }

  initSubCategoriesMenu();
  initSmartBanner();
  handleNewColorSelection();

  await initThirdLevelURL();
  await initFiltering();

  if (document.querySelector('[data-collection-grid]')) {
    // Enable click on add to cart alt buttons
    // addToCartAlt();

    // Full width PLP for AB Testing
    // fullWidthABTesting();

    document.addEventListener('astr-plp-mb-built', (e) => {
      keepSameHeightTitles();
    });
  }

  initSEO();

  window.addEventListener('resize', debounce(() => {
    keepSameHeightTitles();
  }, 100));
};
